export default __webpack_public_path__ + "static/media/1 gehanee.22e1a0a5.jpg";